/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext } from "react";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";
import { useFirestore } from "../../firebase/FirestoreContext";
import { getAuth } from "firebase/auth";
import { collection, getDocs, query, where, doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import config from "../../config";
import ListItem_Favorites from "../../elements/ListItem_Favorites";
import { CircularProgress } from "@mui/material"; // Import CircularProgress
import isProductAvailable from "../../functions/isProductAvailable";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const Favorites = ({ isDevMode }) => {
  const [availableProducts, setAvailableProducts] = useState([]);
  const [outOfStockProducts, setOutOfStockProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const db = useFirestore();
  const auth = getAuth();
  const user = auth.currentUser;
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    const fetchFavoriteProducts = async () => {
      if (!user || !db) {
        console.log("No user or Firestore instance");
        setLoading(false); // Set loading to false if no user or db
        return;
      }

      try {
        setLoading(true); // Set loading to true before fetching data
        const favoritesRef = collection(db, `Users/UsersList/DataBase/${user.uid}/FavoriteProducts`);
        const favoritesSnapshot = await getDocs(favoritesRef);

        const productIds = favoritesSnapshot.docs.map((doc) => doc.data().product_id);

        // Fetch product details for each favorite product
        const available = [];
        const outOfStock = [];
        // Use Promise.all to fetch products in parallel
        await Promise.all(
          productIds.map(async (productId) => {
            const productRef = doc(db, `${collectionPath}Listings/ListingsList/DataBase`, productId);
            const productSnapshot = await getDoc(productRef);
            if (productSnapshot.exists()) {
              const productData = { id: productSnapshot.id, ...productSnapshot.data() };
              if (isProductAvailable(productData)) {
                available.push(productData);
              } else {
                outOfStock.push(productData);
              }
            }
          })
        );

        setAvailableProducts(available);
        setOutOfStockProducts(outOfStock);
      } catch (error) {
        console.error("Error fetching favorite products:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    fetchFavoriteProducts();
  }, [user, db, collectionPath]);

  return (
    <>
      <Header search={false} />
      <div style={{ display: "flex", flexDirection: "column", maxWidth: "1140px", margin: "0 auto" }}>
        <div
          style={{
            padding: "20px 5",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            borderTop: "1px solid black",
            marginTop: 35,
          }}
        >
          <div style={{ padding: "20px 0" }}>
            <div style={{ ...styles.title }}>My Favorites</div>
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 20, flex: 1, minHeight: 300, color: "silver" }}>
                Loading...
              </div>
            ) : (
              <div css={styles.grid}>
                {availableProducts.length > 0 && (
                  <>
                    {availableProducts.map((product) => (
                      <ListItem_Favorites
                        key={product.id}
                        product={product}
                        displayType={"horisontal"}
                        ribbonSettings={{
                          blockedStatus: ["previouslyViewed"],
                        }}
                        screenType={"favorites"}
                        available={true}
                      />
                    ))}
                  </>
                )}

                {outOfStockProducts.length > 0 && (
                  <>
                    <div style={{ ...styles.subtitle }}>Currently Unavailable</div>
                    {outOfStockProducts.map((product) => (
                      <ListItem_Favorites
                        key={product.id}
                        product={product}
                        displayType={"horisontal"}
                        ribbonSettings={{
                          blockedStatus: ["previouslyViewed"],
                        }}
                        screenType={"favorites"}
                        available={false}
                      />
                    ))}
                  </>
                )}

                {availableProducts.length === 0 && outOfStockProducts.length === 0 && <p style={{ padding: 20 }}>No favorite products yet.</p>}
              </div>
            )}
          </div>
        </div>
        <div style={{ height: 100 }} />
        <FAQ />
      </div>
      <Footer />
    </>
  );
};

const styles = {
  grid: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    [mq[0]]: {
      flexDirection: "row",
      flexWrap: "wrap",
    },
  },
  title: {
    fontSize: "1.3rem",
    fontWeight: "600",
    marginBottom: 20,
    padding: "0 10px",
  },
  subtitle: {
    fontSize: "1rem",
    fontWeight: "600",
    marginBottom: 10,
    padding: "0px 20px",
    marginTop: 20,
  },
};

export default Favorites;
